export default {
    province: {
        name: 'จังหวัด',
        placeholder: 'เลือกจังหวัด',
        required: 'กรุณาระบุจังหวัด',
        too_short: '',
        invalid: '',
    },
    district: {
        name: 'เขต / อำเภอ',
        placeholder: 'เลือกเขต / อำเภอ',
        required: '',
        too_short: '',
        invalid: '',
    },
    subDistrict: {
        name: 'แขวง / ตำบล',
        placeholder: 'เลือกแขวง / ตำบล',
        required: '',
        too_short: '',
        invalid: '',
    },
    carBrand: {
        name: 'ยี่ห้อรถยนต์',
        placeholder: 'เลือกยี่ห้อรถยนต์',
        required: '',
        too_short: '',
        invalid: '',
    },
}